export const sendCustomLog = (event, group, props) => {
  window.trimbleInsightsLogger?.sendEvent(
    new window.trimbleInsightsLogger.BaseEvent(event, group, props)
  );
};
